import Phaser from 'phaser';

/**
 * Create an off-screen RenderTexture (not added to the display list).
 * Wraps the untyped `scene.make.renderTexture()` call in a single location.
 */
export function makeRenderTexture(
  scene: Phaser.Scene,
  width: number,
  height: number,
): Phaser.GameObjects.RenderTexture {
  return (scene.make as any).renderTexture({ width, height, add: false }) as Phaser.GameObjects.RenderTexture;
}
